import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../../../../../../components/CiscoUi';

export type IpAddressesModalCloseButtonProps = {
  onClose: VoidFunction;
};

export const IpAddressesModalCloseButton = ({
  onClose,
}: IpAddressesModalCloseButtonProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-center dbl-margin-top">
      <Button
        onClick={onClose}
        colour="ghost"
        size="large"
        aria-label="Close modal"
      >
        {t('buttons.close')}
      </Button>
    </div>
  );
};
